import gql from 'graphql-tag'
import client from '../../stores/apollo'
import { NeighborhoodSpaceFragment } from '@api/fragments'
import { INeighborhoodSpace } from '@api/types'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  deleteWorkplaceGroupsFromSpaces: {
    spaces: INeighborhoodSpace[]
  }
}

const mutateHandler = handleFetchResult<IPayload, INeighborhoodSpace[]>({
  handler: (data) => data.deleteWorkplaceGroupsFromSpaces.spaces,
  name: 'Spaces',
})

export const removeWorkplaceGroupsFromSpacesMutation = gql`
  mutation DeleteWorkplaceGroupsFromSpaces($input: DeleteWorkplaceGroupsFromSpacesInput!) {
    deleteWorkplaceGroupsFromSpaces(input: $input) {
      spaces {
        ...NeighborhoodSpaceFragment
      }
    }
  }
  ${NeighborhoodSpaceFragment}
`

export default function removeWorkplaceGroupsFromSpaces(
  spaceIds: string[]
): Promise<INeighborhoodSpace[]> {
  const input = { spaceIds }

  return client.gql
    .mutate({
      mutation: removeWorkplaceGroupsFromSpacesMutation,
      variables: { input },
    })
    .then(mutateHandler)
}
